import React, { Component } from "react";

import classes from "./Modal.module.css";
// import Aux from "../../../hoc/Aux/Aux";
import Backdrop from "../Backdrop/Backdrop";
// import { motion } from "framer-motion";
class Modal extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.show !== this.props.show ||
      nextProps.children !== this.props.children
    );
  }

  componentWillUpdate() {
    // console.log("[Modal] WillUpdate");
  }

  render() {
    return ( 
      <div>
        <Backdrop show={this.props.show} clicked={this.props.modalClosed} />
        <div

          className={`${classes.Modal} modal-lg`}
          style={{
            // transform: this.props.show ? "translateY(0)" : "translateY(-100vh)",
            opacity: this.props.show ? "1" : "0",
            ...this.props.modalStyle,
          }}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Modal;
